module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "height": "35px"
    }
  }, [(_vm.label && _vm.label.length > 0) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fg-line",
    staticStyle: {
      "padding-top": "7px",
      "padding-bottom": "7px"
    },
    style: ({
      'pointer-events': _vm.isEnabled ? 'all' : 'none'
    })
  }, [_c('label', {
    staticClass: "m-b-0"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.text1) + "  \n        ")]), _vm._v(" "), _c('label', {
    staticClass: "m-b-0"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": "2"
    }
  }), _vm._v("  " + _vm._s(_vm.text2) + "  \n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0898065a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/threecheckbox.vue
// module id = 544
// module chunks = 23